import React from 'react';
import { Box, Text, VStack, Icon, Button } from '@chakra-ui/react';
import { FaCalendarTimes } from 'react-icons/fa';
import './RegistrationClosed.scss';

const RegistrationClosed = ({formRef}) => {
    return (
        <div className="form-area registration-closed-container" ref={formRef}>
            <VStack spacing={6} textAlign="center">
                <Icon as={FaCalendarTimes} boxSize={16} color="#e74c3c" />
                
                <VStack spacing={2}>
                    <Text className="main-heading">
                        Registration Closed
                    </Text>
                    
                    <Text className="message">
                        We're sorry, but the registration for Alumni Connect 2026 has ended.
                    </Text>
                    
                    <Text className="sub-message">
                        We look forward to seeing you at future events!
                    </Text>
                </VStack>
            </VStack>
        </div>
    );
}

export default RegistrationClosed;